export default{
    starsCash:{
        memberApplyPageSearch:"/cash/memberManage/cashingApplyPageSearch", //星店提现列表
        cashingApplyPageSearch:"/cash/starstoreManage/cashingApplyPageSearch",
        srarsFistAudit:"/cash/starstoreManage/fistAudit",    //新店提现初审
        srarsSecondAudit:"/cash/starstoreManage/secondAudit",    //新店提现复审
        cashingApplyDetail:"/cash/starstoreManage/cashingApplyDetail/",  //新店提现详情
        memberApplyDetail:"/cash/memberManage/cashingApplyDetail/", //会员提现详情
        memberFistAudit:"/cash/memberManage/fistAudit", //会员提现初审
        memberSecondAudit:"/cash/memberManage/secondAudit", //会员提现复审
        storeExportCashingApply:'/cash/starstoreManage/exportCashingApply',//星店提现列表导出
        memberExportCashingApply:'/cash/memberManage/exportCashingApply',
        multiFistAudit:'/cash/starstoreManage/multiFistAudit',//星店批量初审
        multiSecondAudit:'/cash/starstoreManage/multiSecondAudit',//星店批量复审
        memberMultiFistAudit:'/cash/memberManage/multiFistAudit',//会员批量初审
        memberMultiSecondAudit:'/cash/memberManage/multiSecondAudit',//会员批量复审
    }
}